import { BaseIdNotRequiredRequest } from "../../../../base/request/BaseIdNotRequiredRequest";
import { toISODate } from "../../../../utils/fechaUtils";
import { VentaAnimalesResponse } from "../response/VentaAnimalesResponse";

/** Request de creación/edición de una venta de animales (`POST .../save`).
 *  `id` null = crear, con valor = editar. El server deriva cantidad/pesos del
 *  array `pesosAnimales`. Se crea con las factories `fx_createVentaAnimales…`. */
export type VentaAnimalesRequest = BaseIdNotRequiredRequest & {
  /** Id del lote/potrero por el que salen los animales. */
  loteSalidaId: string;
  /** Fecha de la venta (ISO). */
  fechaVenta: string;
  /** Precio por kilo pagado. */
  precioKilo: number;
  /** Pesos individuales de cada animal vendido (kg). */
  pesosAnimales: number[];
};

export const fx_createVentaAnimalesRequestEmpty = (): VentaAnimalesRequest => {
  return {
    id: null,
    loteSalidaId: "",
    fechaVenta: toISODate(new Date()),
    precioKilo: 0,
    pesosAnimales: [],
  };
};

export const fx_createVentaAnimalesRequest = (
  response: VentaAnimalesResponse,
): VentaAnimalesRequest => {
  return {
    id: response.id,
    loteSalidaId: response.loteSalida.id,
    fechaVenta: response.fechaVenta,
    precioKilo: response.precioKilo,
    pesosAnimales: [...response.pesosAnimales],
  };
};
